import { createContext } from "react";

export interface HseInstanceContextValue {
    instanceId: number;
    productInstanceId: number;
    setInstanceId: (instanceId: number) => void;
}

export const HseInstanceContext = createContext<HseInstanceContextValue | null>(null);
